import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

const CandleStickChart = ({ data }) => {
  console.log("🚀 ~ CandleStickChart ~ data:", data);
  const theme = useSelector((state) => state.theme.theme);

  const [options, setOption] = useState({
    chart: {
      type: "candlestick",
    },
    plotOptions: {
      candlestick: {
        colors: {
          upward: "#00FF00", // Green for bullish
          downward: "#FF0000", // Red for bearish
        },
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        style: {
          colors: theme === "dark" ? "#fff" : "#000", // Change X-axis label color
          fontSize: "12px", // Adjust font size
        },
      },
    },
    yaxis: [
      {
        opposite: true, // Position Y-axis labels on the right
        labels: {
          style: {
            colors: theme === "dark" ? "#fff" : "#000", // Change X-axis label color
            fontSize: "12px", // Adjust font size
          },
        },
      },
    ],
  });

  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    let instoptions = options;
    console.log("themethemeCHARTTT", theme);
    instoptions.xaxis.labels.style.colors = theme === "dark" ? "#fff" : "#000";
    instoptions.yaxis[0].labels.style.colors =
      theme === "dark" ? "#fff" : "#000";
    setRefresh(false);
    setOption({
      ...instoptions,
    });
    setTimeout(() => {
      setRefresh(true);
    }, [1]);
  }, [theme]);

  console.log("optionsoptions", options);

  const [series, setSeries] = useState([
    {
      data: [],
    },
  ]);

  useEffect(() => {
    let setData = data?.filter((val) => val.x != null);
    setSeries([{ data: setData }]);
  }, [data]);

  return (
    <div>
      {refresh && (
        <Chart
          options={options}
          series={series}
          type="candlestick"
          height={350}
        />
      )}
    </div>
  );
};

export default CandleStickChart;
